import React from 'react';
import { Check, Zap, ArrowRight } from 'lucide-react';
import { pricing, businessInfo } from '../data/mock';

const Pricing = () => {
  const handleWhatsAppClick = (planName) => {
    const message = encodeURIComponent(
      `Olá! Tenho interesse no ${planName} do Centro de Lutas Jardim da Penha. Gostaria de saber como faço para me matricular.`
    );
    window.open(`https://wa.me/${businessInfo.whatsapp}?text=${message}`, '_blank');
  };

  return (
    <section id="precos" className="py-24 bg-gradient-to-b from-bg-card to-bg-page relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNkYzI2MjYiIGZpbGwtb3BhY2l0eT0iMC4wNSI+PHBhdGggZD0iTTM2IDEzNGg3di03aC03eiIvPjwvZz48L2c+PC9zdmc+')] opacity-40"></div>
      
      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="heading-2 text-white mb-6 uppercase tracking-tighter">
            Escolha Seu Plano
          </h2>
          <p className="body-large text-gray-400 max-w-2xl mx-auto">
            Invista na sua transformação. Preços justos, sem pegadinhas, com tudo incluído.
          </p>
        </div>

        {/* Pricing Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6 max-w-[1400px] mx-auto">
          {pricing.map((plan) => {
            const getUniqueBg = (name) => {
              const n = name.toLowerCase();
              if (n.includes('muay thai')) return 'muay_thai_silhouette_bg_1774631485469.png';
              if (n.includes('kickfit')) return 'kickfit_subtle_bg_v2_1774632275520.png';
              if (n.includes('boxe')) return 'boxing_bag_subtle_bg_1774631516829.png';
              if (n.includes('jiujitsu')) return 'jiujitsu_roll_subtle_bg_1774631500408.png';
              if (n.includes('kids')) return 'kids_martial_arts_subtle_bg_v2_1774631577085.png';
              return 'subtle_gym_texture_bg_1774630285219.png';
            };

            return (
              <div
                key={plan.id}
                className="relative group glass-card border-white/5 rounded-2xl p-6 flex flex-col hover:border-brand-primary transition-all duration-300 overflow-hidden"
              >
                {/* Unique Discipline-Aware Background */}
                <div 
                  className="absolute inset-0 opacity-20 group-hover:opacity-40 transition-opacity duration-500 bg-cover bg-center grayscale"
                  style={{ backgroundImage: `url('${getUniqueBg(plan.name)}')` }}
                ></div>

                <div className="relative z-10 flex flex-col h-full">
                  {/* Plan Header */}
                  <div className="text-center mb-6">
                    <h3 className="text-xl font-black text-white mb-1 uppercase">
                      {plan.name}
                    </h3>
                    <p className="text-xs text-secondary-yellow font-bold uppercase tracking-wider mb-4">
                      {plan.description}
                    </p>

                    {/* Price */}
                    <div className="mb-2">
                      {plan.originalPrice && (
                        <span className="text-gray-500 line-through text-base mr-2">
                          {plan.originalPrice}
                        </span>
                      )}
                      <div className="flex items-baseline justify-center">
                        <span className="text-4xl font-black text-white">
                          {plan.price}
                        </span>
                        <span className="text-gray-400 text-sm ml-1">
                          {plan.period}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Features */}
                  <ul className="space-y-3 mb-8 flex-grow">
                    {plan.features.map((feature, index) => (
                      <li key={index} className="flex items-start space-x-2">
                        <Check className="w-4 h-4 text-brand-primary flex-shrink-0 mt-1" />
                        <span className="text-gray-300 text-sm leading-tight">{feature}</span>
                      </li>
                    ))}
                  </ul>

                  {/* CTA */}
                  <button
                    onClick={() => handleWhatsAppClick(plan.name)}
                    className="w-full group flex items-center justify-center font-bold text-sm py-3 btn-primary mt-auto"
                  >
                    {plan.cta}
                    <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                  </button>
                </div>
              </div>
            );
          })}
        </div>

        {/* Additional Info */}
        <div className="mt-16 text-center">
          <p className="text-gray-500 text-base mb-4">
            Todos os planos incluem acesso às modalidades especificadas
          </p>
          <p className="text-2xl text-white font-bold">
            Primeira aula experimental 100% gratuita • Sem compromisso
          </p>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
